const PrivacyPolicy = () => {
  return (
    <div className="content">
      <div
        className="container"
        style={{
          maxWidth: "800px",
          padding: "24px",
          color: "#2b3136",
          lineHeight: "1.8",
          textAlign: "left",
        }}
      >
        <h1 style={{ fontSize: "28px", fontWeight: 600, textAlign: "center" }}>
          SAMPO HOME PLUS AI 隱私權政策
        </h1>
        <p>最後更新日期：2026年8月25日</p>
        <p>生效日期：2026年8月25日</p>

        <p>
          聲寶股份有限公司（以下稱「本公司」）重視您的隱私與個人資料安全。本隱私權政策說明您使用
          SAMPO HOME PLUS AI 行動應用程式及相關服務（以下稱「本服務」）時，本公司如何蒐集、處理、利用及保護您的個人資料。
        </p>
        <p>本服務主要提供予台灣地區使用者，並依中華民國個人資料保護法及相關法令辦理。</p>

        <h2>一、個人資料蒐集者</h2>
        <p>公司名稱：聲寶股份有限公司</p>
        <p>服務名稱：SAMPO HOME PLUS AI</p>
        <p>客服電話：0800-00-5438</p>

        <h2>二、蒐集目的</h2>
        <p>本公司可能基於下列目的蒐集、處理及利用您的個人資料：</p>
        <ol>
          <li>建立、驗證及管理使用者帳號。</li>
          <li>提供智慧家電新增、綁定、連結、遠端控制、排程、分享及通知功能。</li>
          <li>維護本服務及連網設備正常運作。</li>
          <li>提供客服、諮詢及售後服務。</li>
          <li>維護帳號、系統及資訊安全。</li>
          <li>分析及改善本服務功能、效能及使用者體驗。</li>
          <li>發送帳號、設備及服務相關之重要通知。</li>
          <li>經您同意後提供產品、活動或優惠資訊。</li>
          <li>履行法令義務或配合依法有據機關之要求。</li>
        </ol>
        <p>
          本公司不會將個人資料用於前述目的之外的無關或逾越之用途。如需作其他利用，將依法律規定辦理告知，並於必要時取得您的同意。
        </p>

        <h2>三、蒐集之資料</h2>
        <p>依您實際使用之功能，本公司可能蒐集下列資料：</p>
        <ol>
          <li>帳號及聯絡資料：電子郵件地址、使用者帳號、使用者識別資訊及登入驗證資料。</li>
          <li>裝置及App資料：網路網路連線及定位資料、行動裝置資訊、作業系統、App版本、網路等服務必要系統紀錄。</li>
          <li>智慧家電資料：設備識別資訊、產品序號、設備名稱、綁定及連結紀錄、連線狀態、設備分享與作業紀錄。</li>
          <li>操作及設定資料：家電控制指令、模式、排程、群組、通知設定及功能使用紀錄。</li>
          <li>客服資料：您聯絡客服、提出申請、投訴或回饋時提供或必要之提供的資料。</li>
          <li>第三方整合資料：您主動使用第三方登入、語音助理或其他智慧家庭平台整合，完成該功能所必要的帳號、授權或設定資料。</li>
        </ol>
        <p>
          如特定設備支援溫度、濕度、電源使用或其他功能，本服務亦可能蒐集該設備回報之相關資料。
        </p>

        <h2>四、資料利用期間、地區、對象及方式</h2>
        <h3>利用期間</h3>
        <p>
          個人資料於您的帳號使用期間持續保存，以及完成蒐集目的、履行法令義務、處理客服、爭議或資訊安全事件所必要的期間持續保存。
        </p>
        <p>
          當蒐集目的消失或已無保存必要時，本公司將依資料性質及系統運作方式刪除、停止處理或利用，或進行去識別化，但法令如有規定為保留或法律責任而須保存必要者，不在此限。
        </p>
        <h3>利用地區</h3>
        <p>
          您的個人資料主要於台灣地區處理及利用。為提供遠端控制、帳號驗證、推播通知、系統維護、資訊安全或第三方整合服務，部分資料可能於相關雲端服務及提供服務之地區進行處理。
        </p>
        <h3>利用對象</h3>
        <p>個人資料可能由下列對象在必要範圍內處理及利用：</p>
        <ol>
          <li>本公司及繼續本公司執行相關業務之人員。</li>
          <li>受本公司委託提供雲端、系統維護、帳號驗證、推播通知、客服或資訊安全服務之廠商。</li>
          <li>您主動使用之第三方登入、語音助理或其他智慧家庭整合服務提供者。</li>
          <li>依法有據要求提供資料之司法、行政或其他政府機關。</li>
          <li>經您同意之其他對象。</li>
        </ol>
        <p>前揭受委託對象僅於提供服務所必要之範圍內，依本公司之指示處理相關資料。</p>
        <h3>利用方式</h3>
        <p>
          本公司可能以自動化或非自動化方式，進行資料之紀錄、儲存、傳輸、查詢、分析、更新、備份、通知、刪除及其他提供本服務所必要之處理。
        </p>

        <h2>五、不提供資料的影響</h2>
        <p>您可以選擇是否提供個人資料，但如您不提供特定功能所必要的資料，可能無法：</p>
        <ol>
          <li>建立、登入或驗證帳號。</li>
          <li>新增、綁定、連結或管理智慧家電。</li>
          <li>使用遠端控制、排程、分享或通知功能。</li>
          <li>使用第三方登入、語音助理或智慧家庭整合功能。</li>
          <li>取得客服、諮詢或售後相關服務。</li>
        </ol>
        <p>未提供選填資料，原則上不影響本服務基本功能的使用。</p>

        <h2>六、您的個人資料權利</h2>
        <p>依個人資料保護法，您得就本公司持有之個人資料行使下列權利：</p>
        <ol>
          <li>查詢或請求閱覽。</li>
          <li>請求製給複製本。</li>
          <li>請求補充或更正。</li>
          <li>請求停止蒐集、處理或利用。</li>
          <li>請求刪除。</li>
        </ol>
        <p>您可透過客服電話提出申請。為保護資料安全，本公司可能要求您提供必要資訊，以驗證申請人身分。</p>
        <p>
          本公司將依個人資料保護法規定之期限處理您的申請。如因法令規定、資訊安全、執行業務所必要或已逾第三人重大權益而無法接受或部分受理申請，將向您說明原因。
        </p>

        <h2>七、帳號與資料刪除</h2>
        <p>解除安裝本App不會自動刪除您已於本公司或相關服務系統的資料。</p>
        <p>
          如您欲刪除帳號或個人資料，請提出申請。本公司完成身份驗證後，將依申請內容及法律規定刪除、停止處理或利用，或去識別化相關資料。
        </p>
        <p>下列資料可能於必要範圍內繼續保存：</p>
        <ol>
          <li>法令或主管機關要求保存之資料。</li>
          <li>處理爭議、申訴或法律程序所必要之資料。</li>
          <li>防止詐欺、濫用或資訊安全事件所必要之紀錄。</li>
          <li>存於正常系統備份或輪替程序中之資料。</li>
          <li>已無法回復識別特定個人之統計或去識別化資料。</li>
        </ol>
        <p>帳號刪除後，相關設備綁定、分享、排程、通知及其他帳號功能可能無法繼續使用或復原。</p>

        <h2>八、通知、資料安全及事故處理</h2>
        <p>本公司可能發送帳號安全、設備變更、系統維護、服務異常及政策變更等必要通知。</p>
        <p>
          本公司將依資料性質及風險採行合理的安全措施，防止個人資料遭受未經授權之存取、使用、洩漏、竄改、毀損或洩漏。
        </p>
        <p>
          如發生個人資料事故，本公司將採取必要之控制及補救措施，並依相關法令通知可能受影響之使用者及主管機關。
        </p>

        <h2>九、未成年人、政策變更及聯絡方式</h2>
        <p>
          本服務並非以未成年人為主要服務對象。未成年人使用本服務並提供個人資料前，應由法定代理人閱覽、瞭解並同意本政策。
        </p>
        <p>
          本公司可能因法令、服務內容或作業變更而修訂本政策。修訂後的政策將公告於本服務、官方網站或其他適當位置，並更新最後更新日期。重大變更將以適當方式通知使用者。
        </p>
        <p>如您對本政策、個人資料處理、帳號刪除或權利行使有任何疑問，請聯絡：</p>
        <p>聲寶股份有限公司</p>
        <p>客服電話：0800-00-5438</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
